import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ai-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Input, {
      ref: "input",
      modelValue: $data.text,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.text) = $event)),
      disabled: $props.disabled,
      footer: false,
      minlength: 2,
      maxlength: 255,
      class: "input-text",
      placeholder: $data.placeholder,
      onKeydown: _withKeys(_withModifiers($options.onConfirm, ["stop"]), ["enter"])
    }, null, 8 /* PROPS */, ["modelValue", "disabled", "placeholder", "onKeydown"]),
    (!$props.disabled && !$data.answered)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          disabled: !$options.can_confirm,
          primary: "",
          tiny: "",
          onClick: $options.onConfirm
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Reply ")
          ])),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "onClick"]))
      : _createCommentVNode("v-if", true),
    (!$props.disabled && !$data.answered && $props.skip)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          class: "ai-option skip",
          onClick: $options.onSkip
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Skip ")
          ])),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"]))
      : _createCommentVNode("v-if", true),
    (!$props.disabled && !$data.answered && $props.skipAll)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 2,
          class: "ai-option skip",
          onClick: $options.onSkipAll
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Skip All ")
          ])),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"]))
      : _createCommentVNode("v-if", true)
  ]))
}